import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { User } from '../shared/services/user/models/user.model';
import { UtilityService } from '../shared/services/utility/utility.service';
import { IGliaUserInfo } from './strategies/glia/glia-user-info.interface';
import { GliaService } from './strategies/glia/glia.service';
import { ZendeskService } from './strategies/zendesk/zendesk.service';

@Injectable({ providedIn: 'root' })
export class SupportScriptService {
    public constructor(private readonly zendeskService: ZendeskService,
                       private readonly gliaService: GliaService,
                       private readonly utilityService: UtilityService,
    ) {}

    public loadUserSupportScript(user: User): void {
        if (!environment.feature.glia) {
            this.loadDefaultScript();
            return;
        }

        const isUSUser: boolean = user?.CountryCode?.toUpperCase() === 'US';
        const userInfo: IGliaUserInfo = {
            name: `${ user.FirstName } ${ user.LastName }`,
            phone: user.TelNum,
            email: user.Email,
            externalId: user.UserName,
            customAttributes: {
                customerId: user.CustomerId,
            },
        };

        // if running from localhost, check user's country code only.
        if (this.utilityService.isLocalhost()) {
            if (isUSUser) {
                // this.zendeskService.unloadScript();
                this.gliaService.loadScript<IGliaUserInfo>(userInfo);

                return;
            }

            this.loadDefaultScript();
            return;
        }

        // if not a US user or on a non-US domain, always load the default support script (Zendesk).
        if (!user || !isUSUser || this.isNonUSDomain()) {
            this.loadDefaultScript();
            return;
        }

        // this.zendeskService.unloadScript();
        this.gliaService.loadScript<IGliaUserInfo>(userInfo);
    }

    public loadDefaultScript(): void {
        this.gliaService.unloadScript();
        // this.zendeskService.loadScript();
    }

    private isNonUSDomain(): boolean {
        const normalizedCurrentDomain = this.utilityService.normalizeDomain(window.location.hostname.toLowerCase());
        const nonUSDomains: string[] = [
            'upscapitaluk.com',
            'upscapitalde.com',
            'upscapitalfr.com',
            'upscapitalit.com',
        ];

        return nonUSDomains.some(domain => normalizedCurrentDomain.endsWith(this.utilityService.normalizeDomain(domain)));
    }
}
